export default __webpack_public_path__ + "static/media/logo-LKPP-footer.9c30eb37.png";